import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EntryService {
  private visitorApiUrl = `${environment.baseUrl.replace('/v1/', '/api/v1/')}visitor-management/`;

  constructor(private http: HttpClient) {}

  getEntries(params: Record<string, any>): Observable<any> {
    let httpParams = new HttpParams();
    Object.keys(params || {}).forEach(key => {
      const value = params[key];
      if (value !== undefined && value !== null && value !== '') {
        httpParams = httpParams.set(key, value.toString());
      }
    });
    return this.http.get(`${this.visitorApiUrl}entries/`, { params: httpParams });
  }

  getEntry(id: number): Observable<any> {
    return this.http.get(`${this.visitorApiUrl}entries/${id}/`);
  }

  createEntry(payload: any): Observable<any> {
    return this.http.post(`${this.visitorApiUrl}entries/`, payload);
  }

  updateEntry(id: number, payload: any): Observable<any> {
    return this.http.put(`${this.visitorApiUrl}entries/${id}/`, payload);
  }

  deleteEntry(id: number): Observable<any> {
    return this.http.delete(`${this.visitorApiUrl}entries/${id}/`);
  }

  uploadFile(file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post(`${environment.baseUrl}upload/`, formData);
  }
}
